(() => {
  let scheduled = false;
  const update = () => {
    document.documentElement.classList.toggle('sc-header-scrolled', window.scrollY > 8);
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  window.addEventListener('pageshow', update);
  update();
})();
